module.exports = __webpack_public_path__ + "img/Ellipse3.f72f5733.png";